import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getPromotionReservations, stopPromotionReservation, refundPromotionReservation } from "../api/promotion-reservations";

export default function usePromotionReservations(bannersOnly) {
  const token = useSelector((state) => state.user.token);
  const [query, setQuery] = useState({ page: 1, limit: 50, search: "", state: "", bannersOnly });
  const [data, setData] = useState({ rows: [], headers: [], total: 0 });
  const [loading, setLoading] = useState(true), [error, setError] = useState(""), [attempt, setAttempt] = useState(0);
  const [saving, setSaving] = useState(false), writing = useRef(false);
  useEffect(() => {
    const abort = new AbortController(); setLoading(true); setError("");
    getPromotionReservations(token, query, abort.signal).then((result) => { if (!abort.signal.aborted) setData(result); })
      .catch(() => { if (!abort.signal.aborted) { setData({ rows: [], headers: [], total: 0 }); setError("گزارش رزروهای تبلیغاتی دریافت نشد؛ دوباره تلاش کنید."); } })
      .finally(() => { if (!abort.signal.aborted) setLoading(false); });
    return () => abort.abort();
  }, [token, query, attempt]);
  async function mutate(row, request) {
    if (writing.current) return false;
    writing.current = true; setSaving(true);
    try {
      if (request) await refundPromotionReservation(token, row, request); else await stopPromotionReservation(token, row);
      setAttempt((value) => value + 1); return true;
    } catch (reason) { throw new Error(reason?.response?.status === 409 ? "وضعیت سفارش تغییر کرده یا قابل بازپرداخت نیست؛ دوباره بارگذاری کنید." : "عملیات انجام نشد؛ وضعیت پرداخت را بررسی کنید."); }
    finally { writing.current = false; setSaving(false); }
  }
  return { ...data, query, loading, error, saving, mutate, reload: () => setAttempt((value) => value + 1),
    apply: (next) => setQuery((current) => ({ ...current, ...next, page: 1 })),
    page: (page) => setQuery((current) => ({ ...current, page })) };
}
